import Stack from "@mui/material/Stack/Stack";
import React from "react";
import Paper from "@mui/material/Paper";
import {
  Button,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import { LoadPositionList } from "../../../../../../domain/usecases/load-position-list";
import { PositionNotFountError } from "../../../../../../domain/errors/position-not-found-error";
import { Position } from "../../../../../../domain/models/position-model";
import { LoadTransfer } from "../../../../../../domain/usecases/load-transfer";
import { useErrorHandler } from "../../../../hooks";
import { useAuditContext } from "../../store";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store";

type Props = {
  loadPositionList: LoadPositionList;
  loadTransfer: LoadTransfer;
};

export const InsertPositionCollector: React.FC<Props> = ({
  loadPositionList,
}) => {
  const getCurrentWarehouse = useSelector<
    RootState,
    () => { id: number; name: string }
  >((state) => state.getCurrentWarehouse);
  const navigate = useNavigate();
  const [code, setCode] = React.useState<string>("");
  const [position, setPosition] = React.useState<Position | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const cxt = useAuditContext();

  const handleError = useErrorHandler((error) => {
    alert("Um erro inesperado aconteceu");
  });

  const onBlur = async () => {
    if (!code) return;
    try {
      setIsLoading(true);
      const warehouse = getCurrentWarehouse();
      const list = await loadPositionList.load({
        warehouseId: warehouse.id,
        filterOptions: { code },
      });
      if (!list || list.length === 0) {
        return alert("Posição não encontada");
      }
      setPosition(list[0]);
    } catch (error: any) {
      if (error instanceof PositionNotFountError) {
        alert(error.message);
      } else {
        handleError(error as Error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = async () => {
    if (!position) {
      return alert("Insira o código da posição antes de continuar.");
    }
    cxt.setPosition(position);
    navigate("/mobile/insert/product-collector");
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <DrawerAppBar
        title="Posição"
        onBack={() => {
          navigate("/mobile/tasks");
        }}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <Paper>
          <Stack spacing={4} sx={{ padding: "20px" }}>
            {position && (
              <Typography fontWeight="bold" fontSize={"26px"}>
                {" "}
                {`${position?.street}.${position?.building}.${position?.level}.${position?.apartment}`}
              </Typography>
            )}
            <Stack direction="row">
              <TextField
                id="outlined-basic"
                label="Código da Posição"
                variant="outlined"
                sx={{
                  mx: "5px",
                }}
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
                onBlur={onBlur}
              />
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  mx: "5px",
                }}
              >
                <QrCodeIcon />
              </Button>
            </Stack>
          </Stack>
        </Paper>

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={handleClick}
        >
          Confirmar
        </Button>
      </Stack>
    </>
  );
};
